import { Typography } from "@mui/material"

export const FontSubtitleOne = ({ text }: { text: string }) => (
    <Typography variant='h6'>{text}</Typography>
)

export const FontSubtitleTwo = ({ text }: { text: string }) => (
    <Typography variant='subtitle1' fontSize={18} fontWeight={600}>{text}</Typography>
)

export const FontSubtitleThree = ({ text }: { text: string }) => (
    <Typography variant='subtitle1' fontSize={16} fontWeight={450}>{text}</Typography>
)

export const FontInputData = ({ text }: { text: string }) => (
    <Typography fontSize={14} color='#7e8299'>{text}</Typography>
)

export const FontNotInputData = ({ text }: { text: string }) => (
    <Typography fontSize={14} color='#7e8299' fontStyle={'italic'}>{text}</Typography>
)